import { ContrastAllergyType, PregnancyStatus } from '@app/api-module/control-centre-api-client';
import {
    ContrastAllergyDropdownOption,
    ContrastAllergyMappingKey,
    PhaseOfContrast,
    PregnancyDropdownOption,
    PregnancyMappingKey,
    RequestRadiologistCallToggleKey,
    ScanRegionRequest
} from './model';

export const DefaultDropdownValue = 'default';
export type DefaultDropdownValue = typeof DefaultDropdownValue;

export const ContrastAllergyDropdownMapping: ReadonlyMap<ContrastAllergyMappingKey, ContrastAllergyDropdownOption> = new Map<
    ContrastAllergyType | DefaultDropdownValue,
    ContrastAllergyDropdownOption
>([
    [DefaultDropdownValue, { display: 'Contrast Allergy? *', value: DefaultDropdownValue, backgroundColor: 'none' }],
    [ContrastAllergyType.Unknown, { display: 'Unknown Contrast Allergy', value: ContrastAllergyType.Unknown, backgroundColor: 'warning' }],
    [ContrastAllergyType.Yes, { display: 'Contrast Allergy', value: ContrastAllergyType.Yes, backgroundColor: 'error' }],
    [ContrastAllergyType.No, { display: 'No Contrast Allergy', value: ContrastAllergyType.No, backgroundColor: 'success' }]
]);
export const PregnancyDropdownMapping: ReadonlyMap<PregnancyMappingKey, PregnancyDropdownOption> = new Map<
    PregnancyStatus | DefaultDropdownValue,
    PregnancyDropdownOption
>([
    [DefaultDropdownValue, { display: 'Pregnancy? *', value: DefaultDropdownValue, backgroundColor: 'none' }],
    [PregnancyStatus.Unknown, { display: 'Pregnancy Unknown', value: PregnancyStatus.Unknown, backgroundColor: 'warning' }],
    [
        PregnancyStatus.YesScanConsent,
        { display: 'Pregnant - Scan Consent', value: PregnancyStatus.YesScanConsent, backgroundColor: 'warning' }
    ],
    [PregnancyStatus.No, { display: 'Not Pregnant', value: PregnancyStatus.No, backgroundColor: 'success' }]
]);

export const RequestCallToggleMapping: ReadonlyMap<RequestRadiologistCallToggleKey, boolean> = new Map<
    RequestRadiologistCallToggleKey,
    boolean
>([
    ['Required', false],
    ['Yes', true],
    ['No', false]
]);

export const PositivePhaseOfContrasts: PhaseOfContrast[] = ['C+'];

export const DefaultTraumaScanRegions: ScanRegionRequest[] = [
    { modality: 'CT', bodyPart: 'Head', phaseOfContrast: 'C-' },
    { modality: 'CT', bodyPart: 'Cervical Spine', phaseOfContrast: 'C-' },
    { modality: 'CT', bodyPart: 'Chest', phaseOfContrast: 'C+' },
    { modality: 'CT', bodyPart: 'Abdomen and Pelvis', phaseOfContrast: 'C+' }
];

export const DefaultStrokeScanRegions: ScanRegionRequest[] = [{ modality: 'CT', bodyPart: 'Head', phaseOfContrast: 'C-' }];

export class ImagingRequestFormConstants {
    public static readonly SUBMITTED_SUCCESS_MESSAGE = 'The request has been successfully saved.';
    public static readonly SUBMIT_VALIDATION_ERROR_MESSAGE = 'The request cannot be saved. Please resolve the errors.';
    public static readonly SUMITTED_FALLBACK_ERROR_MESSAGE =
        'This request cannot be submitted. Please refresh the page and ' +
        'try again. If the issue persists, please contact Everlight support team.';

    public static readonly CLINICAL_DISCUSSION_DIALOGUE_MESSAGE = 'Call with Everlight Radiology';
}
